import React from 'react'
import { Redirect } from 'react-router-dom'
import { getItem } from '../../api/utils'
import {
  Table,
  Row,
  Col,
  Button,
  Tag,
  Icon,
  Input,
  Modal
} from 'antd'
import API from '../../api/index'
import Action from './action'
const Search = Input.Search

const LoyaltyList = (props) => {
  const [loyalties, setLoyalties] = React.useState([])
  const [search, setSearch] = React.useState(undefined)
  const [is_search, setIs_search] = React.useState(false)
  const [redirect, setRedirect] = React.useState(undefined)
  const [page, setPage] = React.useState(1)
  const [Delete, setDelete] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(undefined)
  const type = getItem('type')
  const columns = [
    {title: '#', dataIndex: 'key', key: 'key'},
    { title: 'Nombre', dataIndex: 'name', key: 'name'},
    {title: 'Activo', dataIndex: 'is_active', key: 'is_active',
      render: (text, record) => {
        return (
          <span>
            {record.is_active ? (
              <Icon type='check-circle' theme='twoTone' twoToneColor='#52c41a' />
            ) : (
              <Icon type='close-circle' theme='twoTone' twoToneColor='red' />
            )}
          </span>
        )
      }
    },
    {title: 'Acción', dataIndex: 'action', key: 'action',
      render: (text, record) => {
        return (
          <span>
            <Tag color='blue' onClick={() => handleViewLoyalty(record._id)}>Ver detalle</Tag>
            <Tag color='orange' onClick={() => handleUpdateLoyalty(record._id)}>Editar</Tag>
            <Tag color='cyan' onClick={() => redirectViewTrade(record._id)}>Ver comercios</Tag>
            <Action loyalty={record} />
            {type === 'Administrador' && (
              <Tag color='#848C8B' onClick={() => handleDelete(record._id)}>Eliminar</Tag>
            )}
          </span>
        )
      }
    }
  ]

  const loyalty = async (page) =>{
    const result = await API.loyalty.list(page)
    setLoyalties(result)
  }

  const handleDelete = async (id) => {
    setDelete(true)
    setDeleteId(id)
  }

  const handleUserDelete = async () => {
    const result = await API.loyalty.deletes(deleteId)
    if (result.nModified === 1) {
      setDelete(false)
      setDeleteId(undefined)
      Modal.success({
        title: 'El programa de fidelidad ha sido eliminado exitosamente'
      })
    }
  }

  const handleAlertNot = () => {
    setDelete(false)
    setDeleteId(undefined)
  }

  const handleDownload = async () => {
    const users = 'loyalty'
    const result = await API.csv.download({
      model: users
    })
    if (result._id) {
      Modal.success({
        title: 'Descarga archivo csv',
        content: `El archivo csv fue enviado a su email exitosamente`
      })
    }
  }

  const getLoyaltyByName = async (page) => {
    const result = await API.loyalty.search(page, search)
    setLoyalties(result)
  }

  const handleClearSearch = () => {
    setIs_search(false)
    setSearch(undefined)
    setPage(1)
    loyalty(1)
  }

  const onSearch = () => {
    setIs_search(true)
    setPage(1)
    getLoyaltyByName(1)
  }

  const handleCreateLoyalty = () => {
    setRedirect('/loyalty/create')
  }

  const handleViewLoyalty = (id) => {
    setRedirect(`/loyalty/detail/${id}`)
  }

  const handleUpdateLoyalty = (id) => {
    setRedirect(`/loyalty/update/${id}`)
  }

  const redirectViewTrade = (id) => {
    setRedirect(`/loyalty/trade/${id}`)
  }

  const handlePrevLoyalty = () => {
    if (page > 1) {
      const pageTemp = page - 1
      setPage(pageTemp)
      loyalty(pageTemp)
    }
  }

  const handleNextLoyalty = () => {
    if (loyalties.length >= 10) {
      const pageTemp = page + 1
      setPage(pageTemp)
      loyalty(pageTemp)
    }
  }

  React.useEffect(() => {
    loyalty(page)
  }, [])

  if (redirect) {
    return (<Redirect to={redirect} />)
  }
  
  return (
    <div>
      <Row style={{ marginBottom: '20px' }}>
        <Col span={8}>
          <h3><strong>Listado de programas de fidelidad</strong></h3>
        </Col>
        <Col span={8}>
          <Search
            value={search}
            name='search'
            placeholder='Ingrese nombre del programa de fidelidad'
            onSearch={() => onSearch()}
            onChange={(event) => setSearch(event.target.value)}
            enterButton
          />
          {search && is_search && (
            <Tag
              color='red'
              style={{ marginTop: '5px' }}
              onClick={() => handleClearSearch()}
            >
              Limpiar busqueda
            </Tag>
          )}
          {Delete && (
            <Modal
              title='Alerta'
              visible={Delete}
              onOk={() => handleUserDelete()}
              onCancel={() => handleAlertNot()}
              okText='Continuar'
              cancelText='Cancelar'
            >
              <p>¿Desea eliminar este programa de fidelidad?</p>
            </Modal>
          )}
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <Button onClick={() => handleDownload()}>Descargar csv</Button>
          {' '}
          <Button onClick={() => handleCreateLoyalty()}>Crear un programa de fidelidad</Button>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={loyalties}
        size='small'
        pagination={{
        position: 'none'
        }}
      />
      <div style={{
        textAlign: 'right',
        marginTop: '10px'
      }}>
        <ul className='ant-pagination '>
          <li className={page === 1 ? ('ant-pagination-disabled ant-pagination-prev') : ('ant-pagination-prev')}>
            <a onClick={() => handlePrevLoyalty()}>Anterior</a>
          </li>
          <li className='ant-pagination-item ant-pagination-item-1 ant-pagination-item-active'>{page}</li>
          <li className={loyalties.length >= 10 ? ('ant-pagination-next') : ('ant-pagination-disabled ant-pagination-next')}>
            <a onClick={() => handleNextLoyalty()}>Siguiente</a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default LoyaltyList
